module.exports = new __parcel__URL__("logo_ofb_h.bebd5f2c.jpg").toString();